import { useState } from "react";
import { Download, AlertTriangle } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { formatFechaHora } from "@/lib/format";
import { RASTREO } from "@/constants/testIds";

const mb = (b) => (b ? `${(b / (1024 * 1024)).toFixed(1)} MB` : "");

// preload="metadata" y sin autoplay: no se descarga el video hasta que el usuario lo reproduce.
export const VideoItem = ({ video, accion }) => {
  const [fallo, setFallo] = useState(false);
  const src = mediaUrl(video.url);
  const descarga = `${src}${src.includes("?") ? "&" : "?"}descargar=1`;
  return (
    <div data-testid={RASTREO.videoItem} className="min-w-0 rounded-[var(--tc-radius)] border border-[var(--tc-border)] bg-black/[0.02] p-3">
      <video
        data-testid={RASTREO.videoPlayer}
        src={src}
        controls
        preload="metadata"
        playsInline
        onError={() => setFallo(true)}
        className="block aspect-video w-full max-w-full rounded bg-black"
      />
      {fallo && (
        <p className="mt-2 flex items-start gap-1.5 text-xs text-amber-700">
          <AlertTriangle size={14} className="mt-0.5 shrink-0" />
          Tu dispositivo no puede reproducir este video aquí. Descárgalo para verlo.
        </p>
      )}
      <div className="mt-2 flex min-w-0 items-center justify-between gap-3 text-xs text-[var(--tc-text-secondary)]">
        <span className="min-w-0 flex-1 truncate">
          {video.nombre || "Video"} · {mb(video.tamano)} {video.creado_en ? `· ${formatFechaHora(video.creado_en)}` : ""}
        </span>
        <span className="flex shrink-0 items-center gap-3">
          <a
            data-testid={RASTREO.videoDownload}
            href={descarga}
            className="inline-flex items-center gap-1 font-medium text-[var(--tc-accent)] hover:underline"
          >
            <Download size={13} /> Descargar
          </a>
          {accion}
        </span>
      </div>
    </div>
  );
};
